import PersonNameComponent from "components/common/Contact/PersonNameComponent/PersonNameComponent";
import Title from "components/common/Title";
import ContactInformation from "components/common/ContactInformation";
import { Field } from "@progress/kendo-react-form";
import AddressInputComponent from "components/common/AddressInputComponent";
import { Input } from "@progress/kendo-react-inputs";
import { FormComboBox, FormDate } from "components/Matters";
import { DocRegisterListTile } from "components/DocumentRegister/DocRegisterListTile";
import { NotesListTile } from "components/Notes/NotesListTile";
import { IdCheck } from "components/IdCheck";
import { RiskAssessment } from "components/RiskAssessments";
import AutoCompleteInput from "components/AutoCompleteCompanies/AutoCompleteCompany";
import { CompanyItemRender } from "components/AutoCompleteCompanies/CompanyItemRender";
import { DocumentList } from "components/Documents/DocumentList";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Form } from "@progress/kendo-react-form";
import styles from "./Clients.module.scss";
import * as api from "../../api/index";
import { PageTabItemTitle } from "components/tabs/TabItem/PageTabItemTitle";
import {
  combineAddressLines,
  handleApiError,
  setClinetFormInitialValues,
} from "Helper";
import { getClientsAllInfo, updateClientViewTab } from "actions/clients.action";
import {
  CompanyInformationView,
  ContactInformationView,
  CreditsInformationView,
  StatementInformationView,
} from "components/Clients";
import { Tile } from "components/UIComponents/Tile";
import { TileWrapper } from "components/UIComponents/TileWrapper";
import { toast } from "react-toastify";
import CustomInput from "components/common/Input";
import ClientMatters from "../../components/Clients/ClientMatters";
import { emailValidator, phoneValidator } from "components/common/validator";
import CompanyDetails from "./CompanyDetails";
import CorrespondenceContact from "./CorrespondenceContact";
import PersonalInformation from "./PersonalInformation";
import StatementBilling from "./StatementBilling";
import CreditsDefaults from "./CreditsDefaults";
import { breakArrayIntoChunks } from "../../components/Clients/UtilityFunction";
import { getCompanyProfile } from "../../api/index";
import {
  ethnicity,
  genders,
  disability,
  typesList,
  companyViewTab,
  companyEditTab,
  personViewTab,
  personEditTab,
} from "./constants";
import { useActiveBranches } from "services/branchService";
import { useCurrentUser } from "services/currentUserService";
import { useActiveVats } from "services/vatService";
import { useActiveCurrencies } from "services/currencyService";
import { useActiveFeeEarner } from "services/userService";
import { getRateCategories, getClientData } from "api";
import { Loader } from "@progress/kendo-react-indicators";
import Asterisk from "components/common/Asterisk";

const AddClients = (props) => {
  const personTab = props.type === "VIEW" ? personViewTab : personEditTab;
  const companyTab = props.type === "VIEW" ? companyViewTab : companyEditTab;
  const isFromView = useSelector((state) => state.clients.clinetEditPermission);
  const { data: branches, loading: branchesLoading } = useActiveBranches();
  const [initialValues, setInitialValues] = useState({
    title: "Mr",
    gender: "Male",
    ethnicity: "White British",
    disability: "Physical",
  });
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [type, setType] = useState({ typeId: 0, typeName: "Company" });
  const [isSaving, setIsSaving] = useState(false);
  const [validation, setValidation] = useState(false);
  const [selected, setSelected] = useState(0);
  const [clientName, setClientName] = useState(null);
  const [reference, setReference] = useState(null);

  // Pass isSaving state to parent
  useEffect(() => {
    if (props.onSavingStateChange) {
      props.onSavingStateChange(isSaving);
    }
  }, [isSaving, props]);
  const { data: user } = useCurrentUser();
  const [branch, setBranch] = useState(null);
  const [clientData, setClientData] = useState(props.data || null);
  const [isLoadingClient, setIsLoadingClient] = useState(false);
  const [comboBoxState, setComboBoxState] = useState({
    ethnicity: null,
    gender: null,
    disability: null,
    currency: null,
    feeEarner: user?.isFeeEarner
      ? {
        userRef: user?.userRef,
        display: `${user?.userRef} - ${user.displayname} `,
      }
      : null,
    vatCodeId: null,
    rateCategoryId: null,
  });
  const [dateState, setDateState] = useState({
    dateOfBirth: null,
    dateOfDeath: null,
    dateStageSet: null,
  });
  const [tabs, setTabs] = useState(
    props.type === "VIEW" || (isFromView && formData?.type === "Person")
      ? personTab
      : companyTab,
  );
  const [companyProfile, setCompanyProfile] = useState();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const initializeRef = useRef(false);

  const { data: currencyData } = useActiveCurrencies();
  const { data: vatData } = useActiveVats();
  const { data: feeEarnerData } = useActiveFeeEarner();
  const [rateCategoryData, setRateCategoryData] = useState([]);

  const fetchRateCategories = async () => {
    try {
      const rateCategoriesData = await getRateCategories();
      const categories = rateCategoriesData?.data?.data || [];
      setRateCategoryData(categories);
      return categories;
    } catch (error) {
      return [];
    }
  };

  const fetchClientData = async (clientId) => {
    if (!clientId) return;
    try {
      setIsLoadingClient(true);
      const response = await getClientData(clientId);
      setClientData(response?.data?.data);
      // setInitialValues(response?.data?.data)
      setIsLoadingClient(false);
    } catch (error) {
      setIsLoadingClient(false);
      toast.error("Failed to load client data");
    }
  };

  useEffect(() => {
    fetchRateCategories();
  }, []);

  // Fetch client data on mount if clientId is provided
  useEffect(() => {
    if (props.clientId) {
      fetchClientData(props.clientId);
    } else if (props.data) {
      setClientData(props.data);
    }
  }, [props.clientId]);

  const handleSelect = (e) => {
    setSelected(e.selected);
  };

  const updatInitialValues = (
    vatCodeName = "",
    feeEarnerName = "",
    ccname = "",
    bname = "",
    rateCategoryName = null,
  ) => {
    let personStateCopy = clientData;
    setInitialValues({
      ...initialValues,
      ...setClinetFormInitialValues(
        personStateCopy,
        vatCodeName,
        feeEarnerName,
        ccname,
        bname,
        rateCategoryName,
      ),
    });
    setDateState({
      dateOfBirth: personStateCopy?.contact?.person?.dateOfBirth
        ? new Date(personStateCopy?.contact?.person?.dateOfBirth)
        : null,
      dateOfDeath: personStateCopy?.contact?.person?.dateOfDeath
        ? new Date(personStateCopy?.contact?.person?.dateOfDeath)
        : null,
      dateStageSet: personStateCopy?.dateStageSet
        ? new Date(personStateCopy?.dateStageSet)
        : null,
    });
    setFirstName(personStateCopy?.contact?.person?.firstName);
    setLastName(personStateCopy?.contact?.person?.lastName);
    setClientName(personStateCopy.clientName);
    setReference(personStateCopy.clientRef);
    setComboBoxState({
      ethnicity: ethnicity[personStateCopy?.contact?.person?.ethnicity],
      gender: personStateCopy?.contact?.person?.gender === "M" ? "Male" : "Female",
      disability: personStateCopy?.contact?.person?.disability,
      vatCodeId: personStateCopy?.vatCodeId
        ? {
          vatCodeId: personStateCopy?.vatCodeId,
          display: vatData?.find(
            (item) => item.vatCodeId === personStateCopy?.vatCodeId,
          )?.display,
        }
        : null,
      feeEarner: personStateCopy?.feeEarnerRef
        ? {
          userRef: personStateCopy?.feeEarnerRef,
          display: `${personStateCopy?.feeEarnerRef} - ${personStateCopy?.feeEarnerName}`,
        }
        : null,
      currency: personStateCopy?.currencyCode
        ? {
          currencyCode: personStateCopy?.currencyCode,
          display: currencyData?.find(
            (item) => item.currencyCode === personStateCopy?.currencyCode,
          )?.display,
        }
        : null,
      rateCategoryId:
        personStateCopy?.rateCategoryId || personStateCopy?.rateId
          ? {
            rateCategoryId:
              personStateCopy?.rateCategoryId || personStateCopy?.rateId,
            rateCategoryName: rateCategoryData?.find(
              (item) =>
                item.rateCategoryId ===
                (personStateCopy?.rateCategoryId || personStateCopy?.rateId),
            )?.rateCategoryName,
          }
          : null,
    });
  };
  const getDispalyNamesForDD = (responseData) => {
    const data = responseData || clientData;

    // any strict guard would block data prefilling
    if (!data) {
      return;
    }

    let vatCodeName = vatData?.find((item) => item.vatCodeId === data.vatCodeId);
    let feeEarnerName = feeEarnerData?.find(
      (item) => item.userRef === data.feeEarnerRef,
    );
    let ccname = currencyData?.find(
      (item) => item.currencyCode === data.currencyCode,
    );
    let rateCategoryName = rateCategoryData?.find(
      (item) => item.rateCategoryId === (data.rateCategoryId || data.rateId),
    );
    let bname = branches?.find((item) => item.branchId === data.branchId);

    setBranch({
      branchName: bname?.branchName,
      branchId: bname?.branchId ?? data.branchId,
    });
    updatInitialValues(
      vatCodeName,
      feeEarnerName,
      ccname,
      bname?.branchName,
      rateCategoryName,
    );
  };

  useEffect(() => {
    if (props.formId == "add" && companyProfile) {
      let selectedAddress =
        companyProfile.service_address ||
        companyProfile.registered_office_address ||
        {};

      let address = {
        // line1: selectedAddress.address_line_1,
        // line2: selectedAddress.address_line_2,
        line1: combineAddressLines(
          selectedAddress.address_line_1,
          selectedAddress.address_line_2,
        ),
        town: selectedAddress?.locality,
        state: selectedAddress.region,
        postcode: selectedAddress?.postal_code,
        country: selectedAddress.country || "",
      };

      let sicCode = breakArrayIntoChunks(companyProfile?.sic_codes, 30);
      setInitialValues({
        ...initialValues,
        clientName: companyProfile?.company_name,
        companyRegNo: companyProfile?.company_number,
        sicCode: sicCode,
        ...setClinetFormInitialValues({
          contact: {
            address: address,
            company: {
              registeredAddress: {
                line1: combineAddressLines(
                  companyProfile.registered_office_address?.address_line_1,
                  companyProfile.registered_office_address?.address_line_2,
                ),
                // line1: companyProfile.registered_office_address.address_line_1,
                // line2: companyProfile.registered_office_address.address_line_2,
                town: companyProfile.registered_office_address?.locality,
                state: companyProfile.registered_office_address.region,
                postcode:
                  companyProfile.registered_office_address?.postal_code || "",
                country: companyProfile.registered_office_address.country || "",
              },
            },
          },
        }),
      });
      getClientReference();
    }
  }, [companyProfile?.company_number]);

  useEffect(() => {
    if (clientData) {
      const { type } = clientData || {};
      setType({ typeId: type === "Person" ? 1 : 0, typeName: type });
    } else if (
      !isLoadingClient &&
      !props.clientId &&
      (props.type === "VIEW" || isFromView)
    ) {
      toast.error("No data found to show.");
    }
  }, [clientData?.clientId, isLoadingClient]);

  useEffect(() => {
    setFormData(clientData || {});
    // Reset initialization flag when client data changes
    initializeRef.current = null;
  }, [clientData?.clientId]);

  // Run when we have client data (view/edit); re-run when lookup data loads so dropdown labels can fill in
  useEffect(() => {
    if ((props.type === "VIEW" || isFromView) && clientData) {
      initializeRef.current = true;
      getDispalyNamesForDD();
    }
  }, [
    vatData?.length,
    feeEarnerData?.length,
    currencyData?.length,
    rateCategoryData?.length,
    branches?.length,
    clientData,
  ]);

  const handleSubmit = async (res) => {
    if (res.preventDefault) res.preventDefault();
    setValidation(true);
    const isFormValid = formRef.current.checkValidity();
    if (!res.values) return;
    if (isFormValid) {
      let dataItem = res.values;
      setIsSaving(true);
      let data = {
        clientRef: reference,
        clientName: clientName || "",
        branchId: branch?.branchId,
        currencyCode: comboBoxState["currency"]?.currencyCode,
        feeEarnerRef: comboBoxState["feeEarner"]?.userRef,
        vatCodeId: comboBoxState["vatCodeId"]?.vatCodeId,
        creditLimit: dataItem?.creditLimit,
        rateCategoryId: comboBoxState["rateCategoryId"]?.rateCategoryId,
        billingName: dataItem.billingName,
        billingPhone: dataItem.billingPhone,
        billingEmail: dataItem.billingEmail,
        billingAddress: {
          line1: dataItem.siline1?.split("\n")?.[0],
          line2: dataItem.siline1?.split("\n")?.[1],
          town: dataItem.sitown,
          state: dataItem.sistate,
          postcode: dataItem.sipostcode,
          country: dataItem.sicountry,
        },
        statementName: dataItem.statementName,
        statementPhone: dataItem.statementPhone,
        statementEmail: dataItem.statementEmail,
        statementAddress: {
          line1: dataItem.biline1?.split("\n")?.[0],
          line2: dataItem.biline1?.split("\n")?.[1],
          town: dataItem.bitown,
          state: dataItem.bistate,
          postcode: dataItem.bipostcode,
          country: dataItem.bicountry,
        },
        active: true,
        type: type?.typeName,
      };
      data.contact = {
        email1: dataItem.email,
        phone1: dataItem.phone1,
        phone2: dataItem.phone2,
        mobileNo: dataItem.mobileNo,
        website: dataItem.website,

        notes: "",
        other1: "",
        active: true,
        type: type?.typeName,
        company: null,
        address: {
          line1: dataItem?.line1?.split("\n")?.[0],
          line2: dataItem?.line1?.split("\n")?.[1],
          town: dataItem?.town,
          state: dataItem?.state,
          postcode: dataItem?.postcode,
          country: dataItem?.country,
        },
        bankAcccount: {
          bankName: dataItem.bankName || "",
          accountType: dataItem.accountType || "",
          accountTitle: dataItem.accountTitle || "",
          accountNo: dataItem.accountNo || "",
          sortCode: dataItem.sortCode || "",
          currencyCode: comboBoxState["currency"]?.currencyCode || "",
          iban: dataItem.iban || "",
        },
      };
      if (type.typeName === "Company") {
        data.contact.company = {
          companyName: "",
          companyRegNo: dataItem.companyRegNo,
          vatNo: dataItem.vatNo,
          sicCode: dataItem.sicCode,
          corrEmail: dataItem?.corrEmail,
          corrPhone: dataItem?.corrPhone,
          corrJobTitle: dataItem?.corrJobTitle,
          corrFirstName: dataItem?.corrFirstName,
          other1: "",
          registeredAddress: {
            line1: dataItem.registeredAddressline1?.split("\n")?.[0],
            line2: dataItem.registeredAddressline1?.split("\n")?.[1],
            town: dataItem.registeredAddresstown,
            state: dataItem.registeredAddressstate,
            postcode: dataItem.registeredAddresspostcode,
            country: dataItem.registeredAddresscountry,
          },
        };

        data.contact.company.correspondenceContact = {
          email1: dataItem.correspondenceContactemail,
          email2: "",
          phone1: dataItem.correspondenceContactphone1,
          phone2: dataItem.correspondenceContactphone2,
          phone3: "",
          mobileNo: dataItem.correspondenceContactmobileNo,
          website: dataItem.correspondenceContactwebsite,
          notes: "",
          other1: "",
          active: true,
          type: "Person",
          person: {
            title: dataItem.title,
            firstName: firstName,
            middleName: dataItem.middleName,
            lastName: lastName,
            letterTitle: "",
            jobTitle: "",
            nameAtBirth: "",
            placeOfBirth: "",
            dateOfBirth: dateState["dateOfBirth"],
            dateOfDeath: dateState["dateOfDeath"],
            ethnicity: comboBoxState["ethnicity"],
            gender: comboBoxState["gender"],
            disability: comboBoxState["disability"],
            niNumber: dataItem?.niNumber,
            other1: "",
          },
          address: {
            line1: dataItem?.correspondenceContactline1?.split("\n")?.[0],
            line2: dataItem?.correspondenceContactline1?.split("\n")?.[1],
            town: dataItem?.correspondenceContacttown,
            state: dataItem?.correspondenceContactstate,
            postcode: dataItem?.correspondenceContactpostcode,
            country: dataItem?.correspondenceContactcountry,
          },
        };
      } else if (type.typeName === "Person") {
        data.clientName = `${firstName || ""} ${lastName || ""}`.trim();
        data.contact.address = {
          line1: dataItem?.line1?.split("\n")?.[0],
          line2: dataItem?.line1?.split("\n")?.[1],
          town: dataItem?.town,
          state: dataItem?.state,
          postcode: dataItem?.postcode,
          country: dataItem?.country,
        };
        data.contact.bankAcccount = {
          bankName: dataItem.bankName || "",
          accountType: dataItem.accountType || "",
          accountTitle: dataItem.accountTitle || "",
          accountNo: dataItem.accountNo || "",
          sortCode: dataItem.sortCode || "",
          currencyCode: comboBoxState["currency"]?.currencyCode || "",
          iban: dataItem.iban || "",
        };
        data.contact.person = {
          title: dataItem.title,
          firstName: firstName,
          middleName: dataItem.middleName,
          lastName: lastName,
          letterTitle: "",
          jobTitle: "",
          nameAtBirth: dataItem.nameAtBirth,
          placeOfBirth: dataItem.placeOfBirth,
          dateOfBirth: dateState["dateOfBirth"],
          dateOfDeath: dateState["dateOfDeath"],
          ethnicity: ethnicity.findIndex(
            (item) => item === comboBoxState["ethnicity"],
          ),
          gender: comboBoxState["gender"] === "Male" ? "M" : "F",
          disability: comboBoxState["disability"] === "Yes" ? 1 : 0,
          niNumber: dataItem.niNumber,
          other1: "",
        };
      }
      try {
        if (props.type === "VIEW" || isFromView || props.formId === "edit") {
          try {
            const updateRes = await api.editClient(formData.clientId, data);
            if (updateRes?.status === 200) {
              toast.success("Client Updated Successfully");
              dispatch(updateClientViewTab(updateRes.data.data));

              // Refetch client data to get fresh values
              if (props.clientId) {
                setClientData(updateRes?.data?.data);
              }

              // Call onSaveSuccess to handle the mode transition
              if (props.onSaveSuccess) {
                props.onSaveSuccess();
              }
            } else {
              toast.error("Client Failed to Update");
            }
          } catch (error) {
            handleApiError(error);
          } finally {
            setIsSaving(false);
          }
        } else {
          try {
            const res = await api.addClient(data);
            if (res?.status === 200) {
              toast.success("Client Added Successfully");
              if (props.component === "Add Matters") {
                props.onChangeClient({
                  display: res?.data?.data.display,
                  name: res?.data?.data.clientName,
                  id: res?.data?.data.clientId,
                  ref: res?.data?.data.clientRef,
                });
              }
              dispatch(
                getClientsAllInfo(res?.data?.data.clientRef, res?.data?.data),
              );
              props.onClose();
            } else {
              toast.error("Client Failed to add");
            }
          } catch (err) {
            const errorM = err?.data?.errorMessage;
            const isDuplicateRef =
              typeof errorM === "string" &&
              errorM.includes("duplicate") &&
              errorM.includes("IX_Clients_ClientRef");
            if (isDuplicateRef) {
              toast.error("Reference already added");
            } else {
              handleApiError(err);
            }
          } finally {
            setIsSaving(false);
          }
        }
      } catch (error) {
        setIsSaving(false);
      }
    }
  };

  const handleTypeNameChange = (e) => {
    if (!e.value) {
      return;
    }
    if (e.value.typeName === "Person") {
      setTabs(personTab);
      setType(e.value);
    } else {
      setTabs(companyTab);
      setType(e.value);
    }
  };

  const handleBranchChange = (e) => {
    setBranch(e.value);
  };

  const getClientReference = async () => {
    if (props.formId !== "add") return;

    const Name =
      type?.typeName === "Person" ? firstName + " " + lastName : clientName;

    if (!Name) return;

    try {
      const response = await api.getClientRefExample(Name);
      setReference(response?.data);
    } catch (error) {
    } finally {
    }
  };

  const handleDateChange = (e, label) => {
    setDateState({
      ...dateState,
      [label]: e.value,
    });
  };

  const handleSelection = async (event) => {
    try {
      const response = await getCompanyProfile(event);
      setCompanyProfile(response?.data);
    } catch (error) {
      // Silently handle error
    }
  };

  useEffect(() => {
    if (branches?.length && user?.branchId && props.formId === "add") {
      const defaultBranch = branches.find(
        (branch) => branch.branchId === user.branchId,
      );
      setBranch(defaultBranch);
    }
  }, [branches, user?.branchId]);

  // Update tabs when mode changes (view <-> edit)
  useEffect(() => {
    if (clientData) {
      const isViewMode = props.type === "VIEW";
      const clientType = clientData.type;
      const newTabs =
        clientType === "Person"
          ? isViewMode
            ? personViewTab
            : personEditTab
          : isViewMode
            ? companyViewTab
            : companyEditTab;

      setTabs(newTabs);
      // When switching to edit, edit mode has fewer tabs; keep selected index in range
      setSelected((prev) =>
        prev >= newTabs.length ? 0 : prev
      );
    }
  }, [props.type, props.formId, clientData?.type]);

  return (
    <div className={styles["matter-form-dialog1"]}>
      {props.type === "VIEW" ? (
        isLoadingClient ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "60vh" }}>
            <Loader type="infinite-spinner" size="large" />
          </div>
        ) : (
          <div className="pt-3 px-4">
            <div className="row">
              <div className={`styles["view-tittle"] `}>
                <TabStrip
                  selected={selected}
                  onSelect={handleSelect}
                  keepTabsMounted={true}
                  className="mt-3 px-3 pagetab pagetab-client">
                  {tabs.map((item, index) => (
                    <TabStripTab
                      title={
                        <PageTabItemTitle
                          client={true}
                          title={item}
                          index={index}
                          selected={selected}
                        />
                      }
                      key={index}>
                      <div>
                        {item === "Contact Information" &&
                          type.typeName === "Company" && (
                            <>
                              <CompanyInformationView
                                data={initialValues}
                                onClose={props.onClose}
                              />
                            </>
                          )}

                        {item === "Company Details" &&
                          type.typeName === "Company" && (
                            <>
                              <div className={`row`}>
                                <Field
                                  disabled={props.type === "VIEW"}
                                  name="companyRegNo"
                                  mr="20px"
                                  label="Registration Number"
                                  ph="e.g 273743383"
                                  width="255px"
                                  component={CustomInput}
                                />
                                <Field
                                  disabled={props.type === "VIEW"}
                                  name="vatNo"
                                  mr="20px"
                                  label="VAT Number"
                                  ph="e.g 273743383"
                                  width="255px"
                                  component={CustomInput}
                                />
                                <Field
                                  disabled={props.type === "VIEW"}
                                  name="sicCode"
                                  mr="20px"
                                  label="SIC Code"
                                  ph="e.g 273743383"
                                  width="255px"
                                  component={CustomInput}
                                />
                                <AddressInputComponent
                                  name="Registered Address"
                                  // address={initialValues?.address}
                                  readOnly={props.type === "VIEW"}
                                  type="registeredAddress"
                                  style={{
                                    marginTop: "20px",
                                    width: "640px",
                                  }}
                                />
                              </div>
                            </>
                          )}

                        {item === "Wills & Deeds" && (
                          <DocRegisterListTile clientId={clientData} />
                        )}

                        {item === "Documents" && (
                          <DocumentList clientId={clientData} />
                        )}

                        {item === "Notes" && (
                          <NotesListTile clientId={clientData?.clientId} />
                        )}

                        {item === "ID Check" && <IdCheck client={clientData} />}

                        {item === "Correspondence Contact" &&
                          type.typeName === "Company" && (
                            <>
                              <div>
                                <div className="flex mt-4">
                                  <Field
                                    disabled={props.type === "VIEW"}
                                    name="title"
                                    style={{ marginRight: "13px" }}
                                    component={Title}
                                  />

                                  <PersonNameComponent
                                    readOnly={props.type === "VIEW"}
                                    required={[false, false, false]}
                                  />
                                </div>
                                <div className={`row gy-4 mt-1`}>
                                  <ContactInformation
                                    readOnly={props.type === "VIEW"}
                                    addType={"correspondenceContact"}
                                    type={type.typeName}
                                    tab="cc"
                                  />
                                </div>
                              </div>
                            </>
                          )}

                        {item === "Contact Information" &&
                          type.typeName === "Person" && (
                            <ContactInformationView
                              data={initialValues}
                              onClose={props.onClose}
                            />
                          )}

                        {item === "Personal Information" && (
                          <ContactInformationView onClose={props.onClose} />
                        )}

                        {item === "Statement & Billing" && (
                          <StatementInformationView data={initialValues} />
                        )}

                        {item === "Credits & Defaults" && (
                          <CreditsInformationView data={initialValues} />
                        )}

                        {item === "Risk Assessment" && (
                          <RiskAssessment clientId={clientData?.clientId} />
                        )}

                        {item === "Matters" && (
                          <ClientMatters list={props.data?.matters} />
                        )}
                      </div>
                    </TabStripTab>
                  ))}
                </TabStrip>
              </div>
            </div>
          </div>
        )
      ) : (
        <div className="pt-3 px-4">
          <div className={`styles["view-tittle"]`}>
            <Form
              initialValues={initialValues}
              onSubmitClick={handleSubmit}
              key={JSON.stringify(initialValues)}
              render={(formRenderProps) => (
                <>
                  <form
                    ref={formRef}
                    onSubmit={handleSubmit}
                    className={`${validation ? "validation" : ""}`}
                    noValidate>
                    <TabStrip
                      selected={selected}
                      onSelect={handleSelect}
                      scrollable={true}
                      keepTabsMounted={true}
                      className="mt-3 px-3 pagetab pagetab-client"
                      style={{
                        userSelect: "none",
                      }}
                      animation={false}>
                      {tabs.map((item, index) => (
                        <TabStripTab
                          title={
                            <PageTabItemTitle
                              client={true}
                              title={item}
                              index={index}
                              selected={selected}
                            />
                          }
                          key={index}>
                          <TileWrapper>
                            {item === "Contact Information" && (
                              <div className="row g-2">
                                <div className="col-12 col-xl-7 ">
                                  <Tile
                                    heading="Contact"
                                    className="px-4 py-2  overflow-auto"
                                    height={"100%"}>
                                    <div className="container pb-2 ">
                                      <div className="row">
                                        <div className={`col-3`}>
                                          <Label className="label">Type</Label>
                                          <ComboBox
                                            disabled={
                                              props.type === "VIEW" || isFromView
                                            }
                                            data={typesList}
                                            required={true}
                                            textField="typeName"
                                            style={{
                                              width: "260px",
                                              height: "32px",
                                              boxShadow:
                                                "0px 1px 9px rgba(0, 0, 0, 0.12)",
                                            }}
                                            placeholder="Select Type"
                                            dataItemKey="typeId"
                                            clearButton={false}
                                            iconClassName="wa"
                                            value={type ?? ""}
                                            onChange={handleTypeNameChange}
                                          />
                                        </div>
                                      </div>
                                      <div className={`row`}></div>
                                      <div className="row mt-2">
                                        {type.typeName === "Company" && (
                                          <div className="col-5 me-4">
                                            <Label>Company Name{!clientName?.trim() && <Asterisk />}</Label>
                                            {props?.formId === "add" ? (
                                              <div className={`${validation && !clientName?.trim() ? "validation-invalid" : ""}`}>
                                                <Field
                                                  // blurRef={getClientReference}
                                                  disabled={props.type === "VIEW"}
                                                  name="clientName"
                                                  label="Company "
                                                  ph="Enter Company Name"
                                                  component={AutoCompleteInput}
                                                  itemRender={CompanyItemRender(
                                                    handleSelection,
                                                  )}
                                                  setClientName={setClientName}
                                                  required={true}
                                                />
                                              </div>
                                            ) : (
                                              <Input
                                                name="clientName"
                                                placeholder="Enter Client Name"
                                                value={clientName ?? ""}
                                                required
                                                onChange={(e) =>
                                                  setClientName(e.target.value)
                                                }
                                                onBlur={getClientReference}
                                                style={{
                                                  width: "260px",
                                                  height: "32px",
                                                }}
                                                disabled={props.type === "VIEW"}
                                              />
                                            )}
                                          </div>
                                        )}
                                      </div>

                                      {type.typeName === "Person" && (
                                        <>
                                          <div className="row mt-2">
                                            <div
                                              className={`col-5  d-flex flex-column justify-content-end`}>
                                              <Label className="label">
                                                First Name
                                                {!firstName?.trim() && (
                                                  <Asterisk />
                                                )}
                                              </Label>
                                              <Input
                                                onBlur={getClientReference}
                                                disabled={props.type === "VIEW"}
                                                name="firstName"
                                                required={true}
                                                placeholder="Enter First Name"
                                                style={{
                                                  width: "260px",
                                                  height: "32px",
                                                }}
                                                value={firstName ?? ""}
                                                onChange={(e) => {
                                                  setFirstName(e.target.value);
                                                }}
                                              />
                                            </div>
                                            <div className="col-1"></div>
                                            <div className="col-4">
                                              <Label className="label">
                                                Last Name
                                                {!lastName?.trim() && <Asterisk />}
                                              </Label>

                                              <Input
                                                onBlur={getClientReference}
                                                disabled={props.type === "VIEW"}
                                                name="lastName"
                                                required={true}
                                                placeholder="Enter Last Name"
                                                style={{
                                                  width: "260px",
                                                  height: "32px",
                                                }}
                                                value={lastName ?? ""}
                                                onChange={(e) => {
                                                  setLastName(e.target.value);
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </>
                                      )}
                                      <div className="row mt-2">
                                        <div
                                          className={`col-5  d-flex flex-column justify-content-end`}>
                                          <Label className="label">
                                            Branch
                                            {!branch && <Asterisk />}
                                          </Label>
                                          <ComboBox
                                            data={branches}
                                            required={true}
                                            textField="branchName"
                                            style={{
                                              width: "260px",
                                              height: "32px",
                                            }}
                                            placeholder="Select Branch"
                                            dataItemKey="branchId"
                                            iconClassName="wa"
                                            value={branch ?? ""}
                                            onChange={handleBranchChange}
                                          />
                                        </div>
                                        <div className="col-1"></div>
                                        <div className={`col-4`}>
                                          <Label className="label">
                                            Client Ref
                                            {!reference?.trim() && <Asterisk />}
                                          </Label>
                                          <Input
                                            disabled={
                                              props.type === "VIEW" ||
                                              props.formId === "edit"
                                            }
                                            maxLength={10}
                                            name="clientRef"
                                            required={true}
                                            placeholder="Enter Client Ref"
                                            style={{
                                              width: "260px",
                                              height: "32px",
                                              boxShadow:
                                                "0px 1px 9px rgba(0, 0, 0, 0.12)",
                                            }}
                                            value={reference ?? ""}
                                            onChange={(e) => {
                                              setReference(e.target.value);
                                            }}
                                          />
                                        </div>
                                      </div>

                                      <div className="row mt-2">
                                        <Field
                                          name={`phone1`}
                                          label="Phone 1"
                                          type="number"
                                          ph="Phone Number"
                                          width={"260px"}
                                          component={CustomInput}
                                          className={`col-5 me-4`}
                                          validator={phoneValidator}
                                        />
                                      </div>

                                      <div className="row mt-2">
                                        <Field
                                          className={`col-5 `}
                                          name={`phone2`}
                                          label="Phone 2"
                                          type="number"
                                          ph="Secondary Phone"
                                          width={"260px"}
                                          component={CustomInput}
                                          validator={phoneValidator}
                                        />
                                        <div className="col-1"></div>
                                        <Field
                                          className={`col-4 `}
                                          label="Email"
                                          name={`email`}
                                          ph="Email Address"
                                          width={"260px"}
                                          validator={emailValidator}
                                          component={CustomInput}
                                        />
                                      </div>
                                      <div className="row mt-2">
                                        <Field
                                          className={`col-5`}
                                          label="Mobile No"
                                          name={`mobileNo`}
                                          type="number"
                                          ph="Enter Mobile Number"
                                          width={"260px"}
                                          validator={phoneValidator}
                                          component={CustomInput}
                                        />
                                        <div className="col-1"></div>
                                        <Field
                                          label="Website"
                                          name={`website`}
                                          ph="Enter Website URL"
                                          width={"260px"}
                                          className={"col-4"}
                                          component={CustomInput}
                                        />
                                      </div>
                                      <div className="mt-2 ">
                                        <AddressInputComponent
                                          name="Address"
                                          contactComponent={`col-6 `}
                                          width={"260px"}
                                          type={""}
                                          style={{
                                            width: "103%",
                                          }}
                                          readOnly={false}
                                        />
                                      </div>
                                    </div>
                                  </Tile>
                                </div>
                                {type.typeName === "Company" ? (
                                  <div className="col-12 col-xl-5">
                                    <Tile
                                      heading="Correspondence Person"
                                      className="px-4  py-2 overflow-auto"
                                      height={"100%"}>
                                      <div className="px-2 pb-2">
                                        <div className="container">
                                          <div className="col-3">
                                            <Field
                                              name={`corrFirstName`}
                                              label="Name"
                                              width={"260px"}
                                              ph="Enter Name"
                                              component={CustomInput}
                                            />
                                          </div>
                                          <div className="col-3 mt-3">
                                            <Field
                                              name={`corrPhone`}
                                              label="Phone Number"
                                              type="number"
                                              width={"260px"}
                                              ph="Enter Phone Number"
                                              component={CustomInput}
                                            />
                                          </div>
                                          <div className="col-3 mt-3">
                                            <Field
                                              name={`corrEmail`}
                                              label="Email"
                                              width={"260px"}
                                              ph="Enter Email Address"
                                              validator={emailValidator}
                                              required={false}
                                              component={CustomInput}
                                            />
                                          </div>
                                          <div className="col-3 mt-3">
                                            <Field
                                              name={`corrJobTitle`}
                                              label="Job Title"
                                              width={"260px"}
                                              ph="Enter Job Title"
                                              component={CustomInput}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </Tile>
                                  </div>
                                ) : (
                                  <div className="col-12 col-xl-5">
                                    <Tile
                                      heading="Personal Details"
                                      className="px-4 py-2 overflow-auto">
                                      <div className="px-2">
                                        <div className="container">
                                          <div className="col-3">
                                            <FormComboBox
                                              name="gender"
                                              label="Gender"
                                              placeholder="Select Gender"
                                              wf={true}
                                              width={"260px"}
                                              mr={"5px"}
                                              data={genders}
                                              isStyled={true}
                                              state={comboBoxState}
                                              onChangeComboBox={(e) => {
                                                setComboBoxState({
                                                  ...comboBoxState,
                                                  gender: e?.value,
                                                });
                                              }}
                                            />
                                          </div>
                                          <div className="col-3 mt-3 form-date-picker">
                                            <FormDate
                                              className={
                                                "form-date-picker note-date-picker "
                                              }
                                              wf={true}
                                              isStyled={true}
                                              width={"260px"}
                                              customLabel={"Date Of Birth"}
                                              label={"dateOfBirth"}
                                              onChangeDate={handleDateChange}
                                              state={dateState}
                                            />
                                          </div>
                                          <div className="col-3 mt-3">
                                            <Field
                                              name="niNumber"
                                              label="NI Number"
                                              mr={"5px"}
                                              ph="Enter National Insurance Number"
                                              width={"260px"}
                                              component={CustomInput}
                                            />
                                          </div>
                                          <div className="col-3 mt-3">
                                            <Field
                                              name="nameAtBirth"
                                              label="Name At Birth"
                                              mr={"5px"}
                                              ph="Enter Name at Birth"
                                              width="260px"
                                              component={CustomInput}
                                            />
                                          </div>{" "}
                                          <div className="col-3 mt-3">
                                            <Field
                                              name="placeOfBirth"
                                              label="Place Of Birth"
                                              mr={"5px"}
                                              ph="Enter Place Of Birth"
                                              width="260px"
                                              component={CustomInput}
                                            />
                                          </div>{" "}
                                          <div className="col-3 mt-3">
                                            <FormComboBox
                                              name="ethnicity"
                                              label="Ethnicity"
                                              placeholder="Select Ethnicity"
                                              wf={true}
                                              width={"260px"}
                                              mr={"5px"}
                                              data={ethnicity}
                                              isStyled={true}
                                              state={comboBoxState}
                                              onChangeComboBox={(e) => {
                                                setComboBoxState({
                                                  ...comboBoxState,
                                                  ethnicity: e?.value,
                                                });
                                              }}
                                            />
                                          </div>
                                          <div className="col-3 mt-3">
                                            <FormComboBox
                                              name="disability"
                                              label="Disability"
                                              placeholder="Select Disability"
                                              wf={true}
                                              width={"260px"}
                                              mr={"5px"}
                                              data={disability}
                                              isStyled={true}
                                              state={comboBoxState}
                                              onChangeComboBox={(e) => {
                                                setComboBoxState({
                                                  ...comboBoxState,
                                                  disability: e?.value,
                                                });
                                              }}
                                            />
                                          </div>{" "}
                                          <div className="col-3 mt-3 pb-3 form-date-picker">
                                            <FormDate
                                              className={
                                                "form-date-picker note-date-picker"
                                              }
                                              wf={true}
                                              isStyled={true}
                                              width={"260px"}
                                              customLabel={"Date Of Death"}
                                              label={"dateOfDeath"}
                                              onChangeDate={handleDateChange}
                                              state={dateState}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </Tile>
                                  </div>
                                )}
                              </div>
                            )}

                            {item === "Company Details" &&
                              type.typeName === "Company" && (
                                <CompanyDetails
                                  initialValues={initialValues}
                                  readOnly={false}
                                />
                              )}

                            {item === "Correspondence Contact" &&
                              type.typeName === "Company" && (
                                <CorrespondenceContact
                                  type={type}
                                  readOnly={false}
                                  handleSelection={handleSelection}
                                />
                              )}

                            {item === "Personal Information" && (
                              <PersonalInformation
                                readOnly={false}
                                comboBoxState={comboBoxState}
                                setComboBoxState={setComboBoxState}
                                dateState={dateState}
                                handleDateChange={handleDateChange}
                              />
                            )}

                            {item === "Statement & Billing" && (
                              <StatementBilling
                                readOnly={false}
                                initialValues={initialValues}
                              />
                            )}

                            {item === "Credit & Defaults" && (
                              <CreditsDefaults
                                readOnly={false}
                                comboBoxState={comboBoxState}
                                setComboBoxState={setComboBoxState}
                                initialValues={initialValues}
                                rateCategoryData={rateCategoryData}
                              />
                            )}

                            {item === "Matters" && (
                              <ClientMatters list={props.data?.matters} />
                            )}

                            <button
                              id="client-submitter"
                              type="submit"
                              style={{ visibility: "hidden" }}
                              onClick={() => formRenderProps.onSubmit()}></button>
                          </TileWrapper>
                        </TabStripTab>
                      ))}
                    </TabStrip>{" "}
                  </form>
                </>
              )}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AddClients;
